export default __webpack_public_path__ + "static/pay-it-faster-video-thumbnail@3x-3801b4d1ea840de033e6ddfe37c1b69d.png";